/**
 * Класс реализует базовую логику для компонента search-result
 */
export default class CSearchResult {
	constructor() {

	}
}
